import { createSlice } from '@reduxjs/toolkit';

export interface CreditNoteProductForEdit {
  id: number;
  productId: number;
  productName: string;
  quantity: number;
  unitCost: number;
  ivaAmount: number;
  totalAmount: number;
  type: 'RETURN' | 'DISCOUNT';
  distributionPercent: number;
  purchaseReferenceCode: string;
}

interface CreditNoteState {
  productToEdit: CreditNoteProductForEdit | null;
  showAddProductModal: boolean;
  showEditProductModal: boolean;
}

const initialState: CreditNoteState = {
  productToEdit: null,
  showAddProductModal: false,
  showEditProductModal: false,
  
};

const creditNoteSlice = createSlice({
  name: 'creditNote',
  initialState,
  reducers: {
    clearProductToEdit(state) {
      state.productToEdit = null;
    },
    openAddProductModal(state) {
      state.showAddProductModal = true;
    },
    closeAddProductModal(state) {
      state.showAddProductModal = false;
    },
    openEditProductModal(state) {
      state.showEditProductModal = true;
    },
    closeEditProductModal(state) {
      state.showEditProductModal = false;
    },
  },
});

export const {
  clearProductToEdit,
  openAddProductModal,
  closeAddProductModal,
  openEditProductModal,
  closeEditProductModal,
} = creditNoteSlice.actions;

export default creditNoteSlice.reducer;
